export default "__VITE_ASSET__D1CAN0MX__"